module.exports = __webpack_public_path__ + "static/valle-de-uco-2a15e126346805bb15196e8457d8f876.jpeg";